<template>
  <DataList
    title="Типи воронки продажів"
    resource="crm-sales-funnel-types"
    :columns="columns"
    :get-items-fn="getTypes"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as salesFunnelTypesApi from "../../backend/salesFunnelTypesApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "Найменування", name: "title" },
      { title: "Дата створення", name: "date" },
    ],
  }),
  methods: {
    async getTypes(...args) {
      return await salesFunnelTypesApi.getTypes(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
